import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";
import LcaDataSection from "./LcaDataSection";
import PackagingSection from "./PackagingSection";
import TransportationSection from "./TransportationSection";

interface RegisterDataSectionsProps {
  vm: IngredientRegisterViewModel;
}

/**
 * Packaging / Transportation / LCA-data sections — all three have been
 * rebuilt in Tailwind (`PackagingSection`, `TransportationSection`,
 * `LcaDataSection`), rendered conditionally exactly as
 * `IngredientRegisterModalView.tsx` gates them today. Formerly
 * `LegacyDataSections.tsx`, renamed once nothing legacy remained here.
 */
const RegisterDataSections = ({ vm }: RegisterDataSectionsProps) => {
  return (
    <>
      {vm.enablePackageData ? (
        <PackagingSection
          ingredientId={vm.ingredientId as string}
          supplierId={vm.supplierId as string}
          refetchPackagingData={vm.refetchPackagingData}
          ingredientPackageData={vm.ingredientPackageData}
        />
      ) : null}

      {vm.enableTransportData ? (
        <TransportationSection
          ingredientId={vm.ingredientId as string}
          supplierId={vm.supplierId as string}
        />
      ) : null}

      {vm.enableLCAData ? (
        <LcaDataSection
          ref={vm.lcaRef}
          ingredientId={vm.ingredientId as string}
          supplierId={vm.supplierId as string}
        />
      ) : null}
    </>
  );
};

export default RegisterDataSections;
